import React from 'react';
import Sidebar from './sidebar';
import Header from './header';
import styles from './styles.module.scss';
import Footer from './footer';
import {useUserContext} from 'providers/user-context';
import classNames from 'classnames';
import withAxiosInterceptor from 'hoc/axios-interceptor';

export const Layout: React.FC<{children: React.ReactNode; hideFooter?: boolean}> = ({
  children,
  hideFooter=false
  }) => {
  const {user} = useUserContext();
  const isHomePage = typeof window !== 'undefined' && window.location.pathname === '/';
  
  return (
    <div className={styles.layout}>
      <Header />
      <div className={classNames(styles.contentWrapper, {[styles.noUser]: !user})}>
        {/* Do not show sidebar/ topbar if user not logged in */}
        {!!user && <Sidebar />}

        <div
          className={classNames(styles.wrapper, {
            [styles.noUser]: !user,
            [styles.home]: isHomePage && styles.home
          })}
        >
          {children}
        </div>
      </div>
      {/* Show footer unless specfied to hide it, in most cases, we will show footer, except rare exceptions */}
      {!hideFooter && <Footer />}
    </div>
  );
};

// Wrapping Layout with withAxiosInterceptor HOC to handle toats and redirects (if specified in response)
export default withAxiosInterceptor(Layout);
